/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
    RecentNotification,
    SAAS_TOKEN_KEY,
} from '@kiute-tech/network-kiute-pro';
import { toast } from 'react-toastify';
import NotificationBox from '@atoms/notificationBox/NotificationBox';
import NotificationBody from '@molecules/notificationBody/NotificationBody';
import { setRecoilExternalState } from '@utils/recoil/RecoilExternalStatePortal';
import { unreadNotificationCountAtom } from '@states/notifications';
import {
    IS_MASTER,
    SERVICE_WORKER_EVENT_TYPES,
    ROUTES,
} from '@utils/constants';
import wait from '@utils/misc/wait';
import { navigateTo } from '@utils/navigation';

const sendDataToWorker = (
    type: string,
    worker: ServiceWorker | null,
    data: Record<string, unknown> = {},
) => {
    const token = localStorage?.getItem(SAAS_TOKEN_KEY);
    if (!token) {
        return;
    }

    /**
     * Take care of the token value from localStorage
     * It contains double quote at begin & end of value
     * */
    worker?.postMessage({
        type,
        data: {
            token: token.replace(/["]+/g, ''),
            ...data,
        },
    });
};

const handleEvent = (event: MessageEvent) => {
    switch (event?.data?.type) {
        case SERVICE_WORKER_EVENT_TYPES.NEW_NOTIFICATION:
            if (!localStorage?.getItem(SAAS_TOKEN_KEY)) break;
            // eslint-disable-next-line no-case-declarations
            const notif = event.data.data as RecentNotification;
            toast(
                <NotificationBox
                    type={
                        notif.bookedPlatform === 'LE_CISEAU'
                            ? 'create'
                            : notif.type
                    }
                    onClick={() => navigateTo(ROUTES.AGENDA_NOTIFICATIONS)}
                >
                    <NotificationBody notif={notif} />
                </NotificationBox>,
            );
            break;
        case SERVICE_WORKER_EVENT_TYPES.UNREAD_COUNT:
            setRecoilExternalState(
                unreadNotificationCountAtom,
                event?.data.data as number,
            );
            break;

        default:
            break;
    }
};

if (navigator.serviceWorker) {
    void (async () => {
        try {
            const registeredWorker = await navigator.serviceWorker.register(
                `${process.env.PUBLIC_URL}/notificationWorker.js`,
                { scope: process.env.PUBLIC_URL || '/' },
            );

            if (!IS_MASTER) {
                // eslint-disable-next-line
                console.log(
                    `NotificationServiceWorker registration successful with scope: ${registeredWorker.scope}`,
                );
            }

            // // Waiting for service worker's init phase
            await wait(3000);

            if (!IS_MASTER) {
                // eslint-disable-next-line
                console.log('Starting NotificationServiceWorker loop');
            }

            const updateTokenLoop = () => {
                sendDataToWorker(
                    SERVICE_WORKER_EVENT_TYPES.TOKEN,
                    registeredWorker.active,
                );
            };

            setInterval(() => {
                updateTokenLoop();
            }, 20000);

            sendDataToWorker(
                SERVICE_WORKER_EVENT_TYPES.INIT,
                registeredWorker.active,
                {
                    fetchUrl: `${
                        process.env.REACT_APP_SAAS_API_URL || ''
                    }/notifications/most-recent?nb-notification=50`,
                    countUrl: `${
                        process.env.REACT_APP_SAAS_API_URL || ''
                    }/notifications/count-unread`,
                },
            );
            navigator.serviceWorker.addEventListener('message', handleEvent);
        } catch (err) {
            console.error('ServiceWorker registration failed: ', err);
        }
    })();
}

export {};
